<template>
  <v-app>
    <v-navigation-drawer
      v-if="$store.state.assignment != null && !$store.state.loading"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list-item-group v-model="$store.state.navIndex" color="primary">
        <template v-for="(item, i) in nav_items">
          <v-list-item
            v-if="(!item.mobile_only || $vuetify.breakpoint.mdAndDown) && (!$store.state.recordingEng || ($store.state.recordingEng && item.recording_eng))"
            :key="i"
            @click="nav(item.nav)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-navigation-drawer>
    <v-app-bar app :clipped-left="$vuetify.breakpoint.lgAndUp">
      <v-app-bar-nav-icon v-if="$store.state.assignment != null && $vuetify.breakpoint.mdAndDown" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title v-if="$store.state.assignment == null && $vuetify.breakpoint.mdAndDown || $vuetify.breakpoint.lgAndUp" class="headline text-uppercase">
        <template v-if="$store.state.assignment == null">
          <span>Director's Choice</span>
          <span class="font-weight-light"> Performance Vendors</span>
        </template>
        <a v-else @click="nav('home')">Back to Assignments</a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        @click="logout"
        v-if="this.$store.state.user"
      >
        <span class="mr-2">Logout</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-overlay :value="$store.state.loading">
        <v-progress-circular indeterminate size="120"></v-progress-circular>
      </v-overlay>
      <v-container>
        <router-view/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'App',
  data() {
    return {
      drawer: null,
      nav_items: [
        { text: 'Home', icon: 'home', nav: 'home', mobile_only: true, recording_eng: true },
        { text: 'Overview', icon: 'pageview', nav: 'overview', recording_eng: true },
        { text: 'Event Schedule', icon: 'schedule', nav: 'event_schedule', recording_eng: true },
        { text: 'Equipment List', icon: 'view_list', nav: 'equipment_list', recording_eng: false },
        { text: 'Finance', icon: 'mdi-calculator', nav: 'finance', recording_eng: false },
        { text: 'Site Staff', icon: 'mdi-account-multiple', nav: 'site_staff', recording_eng: false },
        { text: 'Downloads', icon: 'mdi-cloud-download', nav: 'downloads', recording_eng: false }
      ]
    }
  },
  methods: {
    logout() {
      const vm = this
      firebase.auth().signOut().then(function() {
        console.log('Logout successful')
        if(vm.$router.currentRoute.name != 'home') {
          vm.$router.push('/')
        }
      }, function(error) {
        console.log(error)
      })
    },
    nav(navView) {
      const vm = this
      vm.drawer = vm.$vuetify.breakpoint.mdAndDown ? false : true
      if(navView == 'home') {
        vm.$router.push('/')
      }
      else {
        if(vm.$store.state.user != null) {
          vm.$store.commit('setNav', navView)
        }
      }
    }
  },
  beforeCreate() {
    const vm = this
    vm.$store.commit('setLoading', true)
    firebase.auth().onAuthStateChanged(function(user) {
      vm.$store.commit('updateUser', user)
      // redirect here avoids issue of vuex user reading null on page refresh
      if(user == null && vm.$router.currentRoute.name != 'home') {
        vm.$router.push('/')
      }
      if(vm.$router.currentRoute.name != 'assignment') vm.$store.commit('setLoading', false)     
    })
  }
}
</script>
